import React from "react";

import * as typography from "@client/shared/typography";
import * as utils from "@client/utils";

import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.DeleteClient) => {
    const title = "Delete client";
    const action = "Delete";
    const quantityText =
        props.next_quantity === 1
            ? "single remaining client"
            : `${props.next_quantity} remaining clients`;

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = () => {
        setIsSubmitting(true);
    };

    return (
        <ManagerLayout
            narrow
            title={title}
            currentClientManagerId={props.client_manager.id}
        >
            <form
                className="flex flex-col space-y-[15px]"
                onSubmit={handleSubmit}
                noValidate
                method="POST"
                action=""
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>{title}</typography.Header>
                </ClientNavigation>
                <p>
                    Please confirm you’d like to remove{" "}
                    <strong>{props.client_manager.name}</strong> as a client.
                </p>

                {props.is_prorating == null ? (
                    <>
                        <typography.P>
                            This client will be removed from any meal plans and programs
                            assigned to them.
                        </typography.P>

                        <typography.P>
                            You can always re-add the client later and their historical
                            data will be available.
                        </typography.P>

                        <typography.P>
                            Once you delete this client, you’ll be be billed{" "}
                            <strong>
                                {utils.formatCurrency(props.next_invoice_sum)}
                            </strong>{" "}
                            next month for your {quantityText}.
                        </typography.P>
                    </>
                ) : (
                    <>
                        <typography.P>
                            This client invite will be removed. Your next invoice will
                            be for{" "}
                            <strong>
                                {utils.formatCurrency(props.next_invoice_sum)}
                            </strong>
                            .
                        </typography.P>
                        <typography.P>
                            This includes a{" "}
                            <strong>{utils.formatCurrency(props.is_prorating)}</strong>{" "}
                            credit for this unused invite.
                        </typography.P>
                    </>
                )}
                <typography.P>
                    You can always click on <strong>Billing</strong> on the menu to see
                    all charges and invoices.
                </typography.P>
                <div className="manager-form max-w-[400px] space-y-[15px]">
                    <forms.Fields form={props.form} />
                </div>
                <typography.Button submit disabled={isSubmitting}>
                    {action}
                </typography.Button>
            </form>
        </ManagerLayout>
    );
};
